const limitProposalReasons = [
  { name: 'altIncome', value: 'Nova fonte de renda' },
  { name: 'income', value: 'Aumento de salário' },
  { name: 'retirement', value: 'Pensão/Aposentadoria' },
  { name: 'spending', value: 'Aumento de consumo' },
  { name: 'trip', value: 'Viagem' },
  { name: 'other', value: 'Outros' },
];

export default limitProposalReasons;
